import { useEffect, useState } from "react"
import ClientProfileSevices from "./clientProfileServices"
import Modal from "react-responsive-modal"
import { CommonUtilities } from "../../commonUtils";
import { format } from "date-fns";
import Pagination from "../Header/Pagination";

export default function LogChange(param: any) {

    let [totalRow, settotalRow] = useState(0);
    let [openFirst, setOpenFirst] = useState(false);
    let [LogChangesListing, setLogChangesListing] = useState<any>([]);

    useEffect(() => {
        if (param.openUI) {
            openFirst = param.openUI
            setOpenFirst(openFirst);
            apiCall();
        }
    }, [param])

    var payload = {
        type: "UserLogChanges",
        pageSize: 10,
        pageNumber: 1
    }

    const closeModalUI = () => {
        setOpenFirst(false);
        param.closeUI(false);
    }

    const apiCall = () => {
        ClientProfileSevices.genericAPIListing(payload).then((value: any) => {
            var obj = (CommonUtilities.relativeDataRemapping(value.data, value.headers.original));
            LogChangesListing = obj
            setLogChangesListing(LogChangesListing);

            ///console.log(LogChangesListing)

            totalRow = value && value.totalRows ? value.totalRows : 0
            settotalRow(totalRow)
        })
    }

    const handleNameOnChange = (n: any) => {
        payload.pageNumber = n.pageNumber;
        payload.pageSize = n.pageSize;
        apiCall()
    }

    const HoverDataBox = (param: any) => {
        let parsedSource = {};
        let parsedUpdated = {};
        ///console.log(param)

        try {
            parsedSource = JSON.parse(param?.sourceData);
        } catch (e) {
            parsedSource = { error: "Invalid source JSON" };
        }

        try {
            parsedUpdated = JSON.parse(param?.updatedData);
        } catch (e) {
            parsedUpdated = { error: "Invalid updated JSON" };
        }

        //console.log(JSON?.stringify(parsedSource, null, 2))
        //console.log(JSON.parse(JSON?.stringify(parsedSource, null, 2)))

        parsedSource = JSON.parse(JSON?.stringify(parsedSource, null, 2));

        let tableHeader: string[] = [];
        let beforeChangesValue: string[] = [];
        let afterChangesValue: string[] = [];


        console.log("parsedSource")
        console.log(parsedSource)
        console.log("parsedUpdated")
        console.log(parsedUpdated)

        if (parsedSource) {
            tableHeader = Object.keys(parsedSource)
            beforeChangesValue = Object.values(parsedSource)
            //console.log(Object.keys(parsedSource))
            //console.log(Object.values(parsedSource))
        }

        parsedUpdated = JSON.parse(JSON?.stringify(parsedUpdated, null, 2));
        if (parsedUpdated) {
            //console.log(Object.keys(parsedUpdated))
            afterChangesValue = Object.values(parsedUpdated)
        }

        if (!parsedSource && parsedUpdated) {

            tableHeader = Object.keys(parsedUpdated)
        }

        return (
            <div className="verticalMediumWide hover-box pull-right pull-left mb">
                <button className="btn-info btn-s">
                    <i className="icon-binocular"></i>
                </button>

                <div className="hover-block textboxDropdownList box rightReset text-right borderRoundedMedium borderRoundedMedium" style={{ border: "1px", width: "1000px" }}>

                    <div className="ws-12 pLarge allowHscroll allowVscroll full-height-vh40" >
                        <div className="ws-3 box">
                            <span className="ws-12 ps text-bold text-center"> Field Name</span>
                            {tableHeader?.map((key: any, index: any) => (
                                <span className="ws-12 ps forceSingleLine text-left border-bottom ">{typeof key === 'object' ? (JSON.stringify(key)) : (key)}</span>
                            ))}
                        </div>
                        <div className="ws-4">
                            <span className="ws-12 ps text-bold"> Before Change</span>
                            {beforeChangesValue?.map((key: any, index: any) => (
                                <span className={"ws-12 ps border-bottom forceSingleLine " + changeCheck(index, beforeChangesValue, afterChangesValue)} >
                                    {key === null || key === '' ? ('Null') : typeof key === 'object' ? (JSON.stringify(key)) : (key)}
                                </span>
                            ))}
                        </div>

                        <div className="ws-4">
                            <span className="ws-12 ps text-bold"> After Change</span>
                            {afterChangesValue?.map((key: any, index: any) => (
                                <span className={"ws-12 ps border-bottom forceSingleLine " + changeCheck(index, beforeChangesValue, afterChangesValue)} >
                                    {key === null || key === '' ? ('Null') : typeof key === 'object' ? (JSON.stringify(key)) : (key)}
                                </span>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const changeCheck = (indexNumber: any, beforeChangesValue: any, afterChangesValue: any) => {
        ///console.log(indexNumber)
        //console.log(beforeChangesValue)
        //console.log(afterChangesValue)
        //console.log(typeof beforeChangesValue)

        //console.log( "beforeChangesValue:"  + Object.entries(beforeChangesValue?.[indexNumber]).length  +" afterChangesValue:"  + Object.entries(afterChangesValue?.[indexNumber]).length)

        console.log(beforeChangesValue?.[indexNumber])

        var returnVal = " "

        if (!beforeChangesValue?.[indexNumber] && afterChangesValue?.[indexNumber]) {
            returnVal = " bg-level7 ";
        } else

            if (beforeChangesValue?.[indexNumber] && !afterChangesValue?.[indexNumber]) {
                returnVal = " bg-level7 ";
            } else

                if ((afterChangesValue?.[indexNumber] && beforeChangesValue?.[indexNumber]) && (beforeChangesValue?.[indexNumber] !== afterChangesValue?.[indexNumber])) {
                    returnVal = " bg-level7 "
                }

        return returnVal;
    }

    return (<>
        <Modal open={openFirst} onClose={() => closeModalUI()} center>

            <div className="box-header-main">
                <h2>Edit Log Changes</h2>
            </div>

            <div className="box-content">

                <div className="ws-12 mbl">
                    <h2 className="ws-11">Showing <span className="info">{totalRow}</span> results</h2>
                    <button className="btn-s icon-btn delete pull-right" onClick={() => apiCall()}> Refresh</button>
                </div>
                <div className="ws-12">

                    <div className="table-responsive_big">

                        {(totalRow > 0) && <table>

                            <thead>
                                <tr>
                                    <th>Log Change Date</th>
                                    <th>First Name</th>
                                    <th>Last Name</th>
                                    <th>Store Procedure Name</th>
                                    <th>Action Name</th>
                                    <th style={{ width: '115px' }}>Show Changes</th>
                                </tr>
                            </thead>

                            <tbody>
                                {
                                    LogChangesListing.map((post: any) => (
                                        <tr>
                                            <td>{format(new Date(post?.logDate), 'MMM dd, yyyy')}</td>
                                            <td>{post?.firstName}</td>
                                            <td>{post?.lastName}</td>
                                            <td>{post?.storeProcedureName}</td>
                                            <td>
                                                {post?.actionTypeName && <a className="btn ws-12 text-center full-width inline pull-none m0" style={{ background: "#1f9bacff", color: "#ffffffff" }}>
                                                    {post?.actionTypeName}
                                                </a>}
                                            </td>
                                            <td>
                                                <HoverDataBox sourceData={post.sourceData} updatedData={post.updatedData} />
                                            </td>
                                        </tr>
                                    ))
                                }

                            </tbody>

                        </table>}
                    </div>

                    {(() => {
                        if (totalRow > 1 && totalRow > 10) {
                            return <div className="ptl"> <Pagination onChange={handleNameOnChange} totalRows={totalRow} /></div>
                        }

                    })()}

                </div>
            </div>
        </Modal>
    </>)
}